import React from 'react';
import PropTypes from 'prop-types';
import * as commonLogic from '../../../logic/CommonLogic';
import SelectModalPanel from './SelectModalPanel';

/**
 * SelectGouki
 */
class SelectGouki extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      gouki: this.props.data.gouki,
      masterList: []
    };
    this.handleModalShowChange = this.handleModalShowChange.bind(this);
    this.isModalOpen = false;
  }

  // このボックスの表示データを取得
  componentDidMount() {
    this.props.comactions.onMountedGouki();
  }

  /**
   * メーカー選択画面を表示する
   */
  handleModalShowChange(checkedList) {
    if (this.isModalOpen) {
      this.isModalOpen = false;
      if (checkedList != null && checkedList != undefined) {
        this.props.data.smartYugikiIds = checkedList;
      }
      this.setState({ masterList: [] });
      $('#modal_gouki_select_panel').hide();
    } else {
      this.isModalOpen = true;
      this.setState({ masterList: this.props.data.itemList.goukiList });
      $('#modal_gouki_select_panel').show();
    }
  }


  render() {
    // const actions = this.props.actions;
    // let itemList = this.props.data.itemList.goukiList;

    // // 画面表示"すべて"を追加する。
    // let displayItemList = [{ gouki: '', display_name: 'すべて' }];
    // if (itemList.length > 0) {
    //   let j = 1;
    //   for (let i = 0; i < itemList.length; i++) {
    //     displayItemList[j++] = itemList[i];
    //   }
    // }

    // const nodes = displayItemList.map((item) => {
    //   return (
    //     <option value={item.gouki} key={item.gouki}>
    //       {item.display_name}
    //     </option>
    //   );
    // });
    // const gouki = this.state.gouki;
    let SelectModalPanelNodes = null;
    if (this.state.masterList.length != 0) {
      SelectModalPanelNodes = (
        <SelectModalPanel
          masterList={this.state.masterList}
          handleModalShowChange={this.handleModalShowChange}
          modalTitle={'号機タイプ'}
          allCheckText={'すべて'}
          checkedList={this.props.data.goukiIds}
          idKey={'gouki'}
          valueKey={'display_name'}
        />
      );
    }


    return (
      <div>
        <div className="ctrl_form_title controlForm__titleSemiRequire--state_enable controlForm__text--state_enable">
          <p>号機</p>
        </div>
        {/* <label className="select">
          <select name="pw_extraction_02" id="selectGouki" value={gouki} onChange={e => this.handleGoukiChange(e.target.value)}>
            {nodes}
          </select>
        </label> */}

        <label className="select_panel_content_parent" onClick={() => this.handleModalShowChange()}>
          <div id="selectGouki" className="select_gouki_content">
            <p>eee</p>
          </div>
        </label>

        <div id="modal_gouki_select_panel" className="modal_select_panel">
          {SelectModalPanelNodes}
        </div>

      </div>
    );
  }
}

SelectGouki.propTypes = {
  actions: PropTypes.any.isRequired,
  comactions: PropTypes.any.isRequired,
  data: PropTypes.any.isRequired
};

export default SelectGouki;
